import { Pipe, PipeTransform } from '@angular/core';
import { SponsorData } from '../../providers/sponsor';

@Pipe({
  name: 'sponsor',
})
export class SponsorPipe implements PipeTransform {

  constructor(
    private sponsorData: SponsorData
  ) {}

  transform(idSponsor: string, idClient: string, eventId: string) {
    return this.sponsorData.getSponsorById(idClient, idSponsor, eventId);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/sponsor/sponsor.ts